module.exports = __webpack_public_path__ + "img/section4.dbba20e9.png";